import React, { useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";
import { MenuCard } from "../components/MenuCard";
import { ProductModal } from "../components/ProductModal";
import { useCart } from "../contexts/CartContext";

const CATS = [
    { id: "burgers", label: "Burgers" },
    { id: "sides", label: "Μερίδες" },
    { id: "drinks", label: "Ποτά" },
];

export const MenuPage = () => {
    const [items, setItems] = useState([]);
    const [cat, setCat] = useState("burgers");
    const [loading, setLoading] = useState(true);
    const [activeItem, setActiveItem] = useState(null);
    const { add } = useCart();

    useEffect(() => {
        api.get("/menu").then(({ data }) => {
            setItems(data.filter((i) => i.category !== "extras" && i.category !== "desserts"));
            setLoading(false);
        });
    }, []);

    const filtered = useMemo(
        () => items.filter((i) => i.category === cat),
        [items, cat]
    );

    // McDonald's-style: burgers open quick modal (for ingredient toggles).
    // Sides/Drinks add directly with one tap.
    const handleCardTap = (it) => {
        if (it.category === "burgers") setActiveItem(it);
        else add(it);
    };

    return (
        <div data-testid="menu-page" className="mx-auto max-w-5xl px-4 sm:px-6 pt-3 pb-32">
            <header className="mb-3">
                <p className="text-[10px] uppercase tracking-[0.3em] text-brand-yellow">Παράδοση 30'</p>
                <h1 className="headline text-3xl sm:text-4xl mt-1">Το Μενού</h1>
            </header>

            <div className="sticky top-16 bg-[#0c0c0e]/95 backdrop-blur-xl py-3 border-b border-white/10 z-20 -mx-4 sm:mx-0 px-4 sm:px-0 mb-4">
                <div className="flex gap-2 overflow-x-auto scrollbar-hide">
                    {CATS.map((c) => (
                        <button
                            key={c.id}
                            data-testid={`cat-${c.id}`}
                            onClick={() => setCat(c.id)}
                            className={`whitespace-nowrap px-6 h-11 font-heading uppercase tracking-wider text-sm font-bold border-2 transition rounded-full active:scale-95 ${
                                cat === c.id
                                    ? "bg-brand-red border-brand-red text-white shadow-lg shadow-brand-red/30"
                                    : "border-white/15 text-white/70 hover:border-brand-red hover:text-white"
                            }`}
                        >
                            {c.label}
                        </button>
                    ))}
                </div>
            </div>

            {loading ? (
                <p className="text-white/50">Φόρτωση...</p>
            ) : filtered.length === 0 ? (
                <p className="text-white/50" data-testid="no-results">Δεν βρέθηκαν προϊόντα.</p>
            ) : (
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-5">
                    {filtered.map((it, idx) => (
                        <MenuCard key={it.id} item={it} index={idx} onOpen={handleCardTap} />
                    ))}
                </div>
            )}

            {activeItem && (
                <ProductModal
                    item={activeItem}
                    onClose={() => setActiveItem(null)}
                />
            )}
        </div>
    );
};
